import CellTower from "@mui/icons-material/CellTower";
import Groups from "@mui/icons-material/Groups";
import ScheduleSend from "@mui/icons-material/ScheduleSend";
import { Stack } from "@mui/material";
import type { FC } from "react";
import { PreviewDetailsSidebarPlatform } from "./preview-sidebar-section/preview-details-sidebar-platform";
import { PreviewDetailsSidebarRecipients } from "./preview-sidebar-section/preview-details-sidebar-recipients";
import { PreviewDetailsSidebarSchedule } from "./preview-sidebar-section/preview-details-sidebar-schedule";
import { PreviewDetailsSidebarSection } from "./preview-sidebar-section/preview-details-sidebar-section";

export const PreviewDetailsSidebar: FC = () => {
  return (
    <Stack direction="column" spacing={0} data-testid="preview-sidebar">
      <PreviewDetailsSidebarSection title="Platform" icon={<CellTower />}>
        <PreviewDetailsSidebarPlatform />
      </PreviewDetailsSidebarSection>
      <PreviewDetailsSidebarSection title="Scheduling" icon={<ScheduleSend />}>
        <PreviewDetailsSidebarSchedule />
      </PreviewDetailsSidebarSection>
      <PreviewDetailsSidebarSection title="Recipients" icon={<Groups />}>
        <PreviewDetailsSidebarRecipients />
      </PreviewDetailsSidebarSection>
    </Stack>
  );
};
